import { gql } from "@apollo/client";

export const PRODUCT_COUNT_QUERY = gql`
  query productCountQuery($vendorId: Int) {
    product(vendorIds: [$vendorId]) {
      data {
        id
      }
      count
    }
  }
`;
